import { useTheme } from "@mui/material";
import { useBoolean } from "usehooks-ts";

import { ControlledAudio, TileBase, TileBaseProps } from "@/components/ui-v2";
import { AudioIcon } from "@/components/ui-v2/icons";

import { AudioPreviewTileControls } from "./AudioPreviewTileControls";

export interface AudioPreviewTileProps extends TileBaseProps {
  url?: string;
  isPlaying?: boolean;
  onAction?: (e: React.MouseEvent, action: AudioPreviewTileAction) => void;
}

export type AudioPreviewTileAction =
  | "SELECT"
  | "DOUBLE_CLICK"
  | "OPEN_CONTEXT_MENU"
  | "TOGGLE_PLAY";

export const AudioPreviewTile = (props: AudioPreviewTileProps) => {
  const {
    url,
    isSelected = false,
    isSelectable = false,
    slots = {},
    slotProps = {},
    onAction,
    ...rest
  } = props;
  const theme = useTheme();
  const {
    value: isPlaying,
    toggle: togglePlaying,
    setFalse: stopPlaying,
  } = useBoolean(false);

  const handleAction =
    (action: AudioPreviewTileAction) => (e: React.MouseEvent) => {
      onAction?.(e, action);
    };

  const handleControlsAction = (
    e: React.MouseEvent,
    action: AudioPreviewTileAction,
  ) => {
    switch (action) {
      case "TOGGLE_PLAY":
        togglePlaying();
        break;
      default:
        onAction?.(e, action);
        break;
    }
  };

  return (
    <TileBase
      isSelected={isSelected}
      isSelectable={isSelectable}
      sx={{ background: theme.palette.secondary[6] }}
      slots={{
        topRightEl: url ? AudioPreviewTileControls : undefined,
        ...slots,
      }}
      slotProps={{
        topRightEl: {
          isPlaying,
          onAction: handleControlsAction,
        },
        ...slotProps,
      }}
      onClick={handleAction("SELECT")}
      onDoubleClick={handleAction("DOUBLE_CLICK")}
      onContextMenu={handleAction("OPEN_CONTEXT_MENU")}
      {...rest}
    >
      <ControlledAudio src={url} isPlaying={isPlaying} onEnded={stopPlaying} />
      <AudioIcon sx={{ color: "white" }} />
    </TileBase>
  );
};
